/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const usersRegistrationsModelSchema = z.object({
    "registrationsCount": z.number().int().describe("Число регистраций"),
"dynamics": z.number().describe("Динамика")
    })